import React, { Fragment, useContext, useEffect, useState } from 'react';
import './Styles.css';
import { LangCtx, PayLoadCtx, CustomCtx, RoleCtx } from "../../lib/context";
import { langObj } from "../../locale/index";
import DropDown from "../../lib/ui/dropdown/Dropdown";
import config from "../../config.json";
import Badge from '@material-ui/core/Badge';
import StarIcon from '@material-ui/icons/Star';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';


import { getDomainDetials } from '../../actions/users';
import { displayFullName } from '../../lib/functions';

const Header = (props) =>
{
    const { l, setLang } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    // const {custom} = useContext(CustomCtx);
    const { role } = useContext(RoleCtx);

    const { custom, setCustom } = useContext(CustomCtx);
    const [logo, setLogo] = useState();
    // console.log("payload in headers======", payload);
    useEffect(() =>
    {
        getDomainDetials(custom.subDomain)
            .then((res) =>
            {
                // setLoading(false);
                if (res.status)
                {
                    if (res.data != null)
                    {
                        // setDomain(res.data.subdomain);
                        setLogo(res.data.logo);
                        setCustom((prev) =>
                        {
                            return { ...prev, logo: res.data.logo ? res.data.logo : '/images/logos/Inconsultlogonew.png' };
                        });
                    }
                }
            })
            .catch((err) =>
            {
                // setLoading(false);
                console.log("err ==== ", err);
            });
    }, []);


    // console.log("role ========",role);


    const handleLang = (e) =>
    {
        setLang(langObj[e.target.value]);
        localStorage.setItem('lang', e.target.value);
    };

    const langOptions = [{ value: "en", label: l.english }, { value: "hi", label: l.hindi }];
    let name = displayFullName(payload);
    return <Fragment>
        <div className="appBar">
            <div className="appIconBox" onClick={props.handleSlide}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="brandingBox">
                <div className="logoBox">
                    <img src={custom.logo} alt="logo" />
                </div>
            </div>
            <div className="flexInline callBtn">
                <a className='tollfree flexInline alignCntr' href="https://help.instavc.com/inconsult" target="_blank">
                    <PlayCircleFilledWhiteIcon className='callIcon' fontSize='small' />{l.help_center}
                </a>
            </div>
            <div className="innerLangBlock">
                <DropDown placeholder="Languages" items={langOptions} value={localStorage.getItem('lang') ? localStorage.getItem('lang') : l.locale || 'en'} onChange={handleLang} />
            </div>
            <div className="webAppBarAction">
                {/* <span className="wlcomTxt">{l.welcome}! <small className="primaryTxt">{payload.consultRole == "Admin" ? name : payload.consultRole == "corporate" ? payload.corporateName : name}</small></span> */}
                <div className="flexAutoCol prfName pdngHMD">
                    <span className="wlcomText">{l.welcome}!</span>
                    <small className="primaryTxt ellipsisTxt txtAlignEnd">{payload.consultRole == "Admin" ? name : payload.consultRole == "corporate" ? payload.corporateName : name}</small>
                </div>
                {
                    role == "SA" ? <div className="setBadge">
                        <Badge color="secondary" overlap="circle" badgeContent={<StarIcon />}>
                            <div className="avtrCircle">
                                <img src={payload?.profileImage?.url && payload.profileImage.url !== config.defaultProfileImage ? payload.profileImage.url : "/images/icons/profile-outline.png"} className={payload?.profileImage?.url && payload.profileImage.url !== config.defaultProfileImage ? "" : "invertWhite"} alt="logo" />
                            </div>
                        </Badge>
                    </div>
                        :
                        <div className="avtrCircle">
                            <img src={payload?.profileImage?.url && payload.profileImage.url !== config.defaultProfileImage ? payload.profileImage.url : "/images/icons/profile-outline.png"} className={payload?.profileImage?.url && payload.profileImage.url !== config.defaultProfileImage ? "" : "invertWhite"} alt="logo" />
                        </div>
                }
            </div>

        </div>
    </Fragment>;
};
export default Header;
